import { Component, input, output } from '@angular/core';
import { EmptyState } from '../../../../core/types/general';
import { GeneralButtonComponent } from '../general-button/general-button.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-empty-state-with-img',
  imports: [TranslateModule, MatIconModule, GeneralButtonComponent],
  templateUrl: './empty-state-with-img.component.html',
  styleUrl: './empty-state-with-img.component.scss',
})
export class EmptyStateWithImgComponent {
  emptyConfig = input.required<EmptyState>();
  showButton = input<boolean>(false);

  buttonClickedEvent = output<void>();
}
